// extracted by mini-css-extract-plugin
export default {"topic":"topicitem_topic__LmC9Z","active":"topicitem_active__R0+TD"};